<template>
<div class="container-fluid">
  <div v-for="attribute in errors" class="alert alert-danger" :key="attribute.field">
      {{attribute.value}}
  </div>
  <h4 class="m-3">Добавление баннера</h4>
  <el-form  :model="form" label-width="180px" label-position="left" id="uploadForm" name="uploadForm" enctype="multipart/form-data">
    <el-form-item label="Название" prop="title">
      <el-input v-model="form.title"></el-input>
    </el-form-item>
    <el-form-item label="Описание" prop="description">
      <el-input type="textarea" v-model="form.description"></el-input>
    </el-form-item>
    <el-form-item label="Название кнопки" prop="btnText">
      <el-input v-model="form.btnText"></el-input>
    </el-form-item>
    <el-form-item label="Ссылка" prop="link">
      <el-input v-model="form.link"></el-input>
    </el-form-item>
      <el-form-item label="Сортировка">
          <el-input type="number" min="0" v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
          <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>
      <el-form-item label="Разделы каталога">
        <el-row>
          <el-button size="small" type="primary" @click="toggleDialog()">Выбрать</el-button>
        </el-row>
        <el-row v-if="selectedSections.length">
          <el-col>
            <el-tag 
              v-for="(it, index) in selectedSections"
              :key="it.id"
              checked
              closable
              @close="handleDeleteCat(index)"
            >{{it.title}}</el-tag>
          </el-col>
        </el-row>
        
      </el-form-item>
      <el-form-item label="Изображение">
      <el-upload
      action=""
      list-type="picture"
      :limit="1"
      :auto-upload="false"
      :on-change="handleChange"
      >
        <el-button size="small" type="primary">Добавить Изображение</el-button>
      </el-upload>
      </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="storeBanner()">Добавить</el-button>
      <el-button @click="back">Отмена</el-button>
    </el-form-item>
  </el-form>
  <CatalogSectionDialog
  v-if="$store.getters.showCatalogSectionDialog"
  :items-payload="selectedSections"
  :is-multiple="true"
  @saveItems="onSaveItems"
  />
</div>
</template>

<script>
import axios from "axios";
import typeObjConfig from '../../composable/config/banner-type-object.config'
import useFormData from '../../composable/useFormData'
import getErrors from '../../composable/utils/getErrors'
import CatalogSectionDialog from '../CatalogSectionDialog'

export default {
  components: {CatalogSectionDialog},
name: "BannerCreate",
  data: function (){
    return {
     form: {
        title: '',
        description: '',
        link:'',
        btnText:'',
        sort: 1,
        activity: true,
        image: '',
        sections: [],
      },
      selectedSections: [],
      showPreview: false,
      imagePreview: '',
      errors:[],
      status:0,
      typeObjConfig,
    }
  },
  methods:{    
    back(){
      this.$router.go(-1)      
    },
    handleChange(v){
      this.form.image = v?.raw || undefined
    },
    storeBanner(){
      const data = useFormData().execute().setFields([
        'image',
        'title',
        'description',
        'link',
        'btnText',
        'sort',
        'activity',
        'sections'
      ]).getFormData(this.form)
      
      axios.post('banner',data).then((response)=>{
        this.status = response.status;
        this.errors ='';
        this.back()
      }).catch((errors)=>{

        if(errors.response.status === 401){
          this.$router.push('/login');
        }

        if(errors.response.status === 422) {
          this.setErrors(errors.response.data.errors)
        }
      });
    },
    setErrors(err) {
      this.errors = getErrors(err)
    },
    toggleDialog() {
      this.$store.commit('showCatalogSectionDialog', !this.$store.getters.showCatalogSectionDialog);
    },
    setFormSection(){
      this.form.sections = this.selectedSections.map(e => e.id)
    },
    handleDeleteCat(index){
      this.selectedSections.splice(index, 1)
      this.setFormSection()
    },
    onSaveItems(items) {
      this.selectedSections = items
      this.setFormSection()
    }
  }
}
</script>

<style>

</style>